import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GuidePage.css';

const GuidePage = () => {
  const navigate = useNavigate();

  return (
    <div className="guide-page">
      <h1 className="guide-title">Руководство пользователя</h1>

      <div className="guide-text">
        <p>
          В начале тут стоит описать кратко возможности приложения и для чего оно нужно. Нужно расписать, что вот сюда как в электронный журнал можно вносить записи о поломках. Функций добавления новых коллекторов или новых серий домов напрямую не предусмотрено.
        </p>
        <p>
          Жилой дом представляет собой девятиэтажное трехсекционное здание с общей площадью около 6770 м² и 105 квартирами. Планировка этажей включает по четыре квартиры на этаж с различной конфигурацией в рядовых и торцевых секциях. Все квартиры имеют раздельные санузлы, хозяйственные шкафы и антресоли. Конструктивная схема — ячеистая, с продольными и поперечными стенами из железобетона. Наружные стены — трёхслойные панели с утеплителем. Дом оснащён пассажирскими лифтами, мусоропроводом, естественной вентиляцией и внутренними водостоками с обогревом. Отопление и горячее водоснабжение централизованные, через теплоцентр. Водоотведение осуществляется в городской коллектор, а противопожарные меры соответствуют действующим СНиП.
        </p>
      </div>


      <h2 className="guide-section-title">Вкладка "Карты"</h2>

      <div className="guide-text">
      Тут надо подробно будет расписать что это за вкладка и какие на ней есть возможности использования. Типо жмяк туда и будет это, а потом жмяк сюда и вообще чудо.  Что у нас при наведении кратко инфу можно получить на карте, но если нажать, то вот там в карточке некие подробности и возможность интерактивно добавить поломку. Можно вставить в некие моменты картинки для большей наглядности.
      </div>

      <div className="guide-image-placeholder">
        (Здесь будет скриншот карточки дома)
      </div>

      <h2 className="guide-section-title">Вкладка "Справочники"</h2>

      <div className="guide-text">
      Тут надо подробно будет расписать что это за вкладка и какие на ней есть возможности использования. Типо жмяк туда и будет это, а потом жмяк сюда и вообще чудо.  Что у нас при наведении кратко инфу можно получить на карте, но если нажать, то вот там в карточке некие подробности и возможность интерактивно добавить поломку. Можно вставить в некие моменты картинки для большей наглядности.
      </div>

      <button className="guide-button" onClick={() => navigate('/collectors')}>
        Перейти к карте
      </button>
    </div>
  );
};

export default GuidePage;
